/* eslint-disable no-unused-vars */
import { Palette } from 'config';
import styled, { css } from 'styled-components';

const breakpoint = 1600;

export const ChangeContainer = styled.div`
  display: flex;
  gap: 4px;
  color: ${({ change }) =>
    change > 0
      ? `${Palette.Teal._600}`
      : !change
      ? `${Palette.PrimaryGray._400}`
      : `${Palette.Red._600}`};
  font-family: 'Roboto';
  font-weight: 500;
  font-size: 16px;
  user-select: none;
  height: 18px;
  align-items: center;

  @media (min-width: ${breakpoint}px) {
    justify-content: flex-end;
  }
`;

export const PrevLoaderWrap = styled.div`
  width: auto;

  & span {
    width: 16px !important;
    height: 16px !important;
    margin-top: 8px;
  }
`;

export const ArrowWrap = styled.div`
  margin-right: auto;
  margin-left: 4px;
  margin-top: ${({ isOpen }) => (isOpen ? '-4px' : '4px')};
  transform: ${({ isOpen }) => (isOpen ? 'unset' : 'rotate(180deg)')};

  svg {
    fill: ${({ isOpen }) => (isOpen ? `${Palette.Primary._500}` : `${Palette.PrimaryGray._400}`)};
  }
`;

export const DataWrap = styled.div`
  display: flex;
  justify-content: space-between;

  @media (max-width: ${breakpoint - 1}px) {
    flex-direction: column;
  }
`;

export const RightContainer = styled.div`
  margin-top: 8px;
  margin-bottom: 8px;

  @media (min-width: ${breakpoint}px) {
    text-align: right;
    align-self: flex-end;
    max-width: 72px;
    margin-top: unset;
    margin-bottom: unset;
  }
`;

export const LabelWrap = styled.div`
  height: 22px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
`;

export const DynamicLabel = styled.div`
  flex-grow: 1;
  max-width: calc(100% - 16px);
`;

export const LabelTextWrap = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 2px;
  width: fit-content;
  max-width: 100%;
  height: 25px;
  padding: 4px;
  margin-left: -4px;
  border-radius: 4px;
  background-color: ${({ isActive }) => (isActive ? `${Palette.Primary._000}` : 'transparent')};
  border: ${({ isActive }) =>
    isActive ? '1px solid' + `${Palette.Primary._300}` : '1px solid transparent'};
  cursor: pointer;
`;

export const LabelText = styled.div`
  width: calc(100% - 20px);
  flex-grow: 1;
  color: ${({ isSelected, isChartHidden, isActive }) =>
    !isSelected && !isChartHidden
      ? `${Palette.PrimaryGray._500}`
      : isActive
      ? `${Palette.Primary._500}`
      : `${Palette.PrimaryGray._700}`};
  font-weight: 500;
  font-size: 14px;
  font-family: 'Roboto';
  user-select: none;
  cursor: pointer;
`;

export const DropDownItem = styled.div`
  color: ${({ isActive }) =>
    !isActive ? `${Palette.PrimaryGray._700}` : `${Palette.Primary._500}`};
  font-weight: 500;
  font-size: 14px;
  font-family: 'Roboto';
  user-select: none;
  cursor: pointer;
  background-color: ${({ isActive }) => (isActive ? `${Palette.Primary._000}` : 'transparent')};
  border: ${({ isActive }) =>
    isActive ? '1px solid' + `${Palette.Primary._300}` : '1px solid transparent'};
  border-radius: 4px;
  padding: 10px 8px;
`;

export const LabelDropDown = styled.div`
  position: absolute;
  top: 25px;
  right: 0;
  width: 100%;
  min-width: 180px;
  max-height: 170px;
  padding: 8px 12px 8px 8px;
  background-color: white;
  outline: 1px solid ${Palette.PrimaryGray._200};
  border-radius: 4px;
  box-shadow: 0px 16px 24px rgba(23, 43, 77, 0.04), 0px 16px 32px rgba(23, 43, 77, 0.08);
  overflow-y: auto;
  z-index: 999;
`;

export const Value = styled.div`
  color: ${Palette.PrimaryGray._700};
  font-weight: 700;
  font-size: 32px;
  font-family: 'Roboto';
  user-select: none;

  @media (max-width: ${breakpoint - 1}px) {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    text-wrap: nowrap;
  }
`;

export const SmallText = styled.div`
  color: ${Palette.PrimaryGray._400};
  font-weight: 400;
  font-size: 12px;
  font-family: 'Roboto';
  user-select: none;
  white-space: pre;
`;

export const TopLine = styled.div`
  width: 100%;
  height: 2px;
  background-color: ${({ isChartHidden, isSelected, color }) =>
    !isSelected && !isChartHidden ? 'transparent' : color.main};
  transfrom: translateY(-1px);
`;

export const AnimatedIconButton = styled.div`
  flex-shrink: 0;
  width: 16px;
  height: 8px;
  cursor: pointer;
  border: 2px solid ${({ color }) => color.main};
  border-radius: 4px;
`;

export const Icon = styled.svg`
  width: 16px;
  height: 8px;
  fill: none;
  stroke-width: 2;
`;

export const Container = styled.div`
  position: relative;
  background-color: ${({ isSelected, isChartHidden }) =>
    isSelected || isChartHidden ? 'white' : 'transparent'};
  border-bottom: ${({ isSelected, isChartHidden }) =>
    isSelected || isChartHidden ? '1px solid white' : '1px solid rgba(226, 232, 240, 1)'};
  border-right: 1px solid rgba(226, 232, 240, 1);
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 16px 24px;
  cursor: ${({ isChartHidden }) => (isChartHidden ? 'auto' : 'pointer')};
`;

export const OuterContainer = styled.div`
  flex-grow: 1;
  width: ${({ numOfTabs }) => 'calc(100% / ' + numOfTabs + ')'};

  &:last-child > div {
    border-right: unset;
  }
`;
